
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { API_BASE_URL, UPDATES_INDENT_STATUS, GET_STOCK_INDENT_LIST, INSERT_STOCK_INDENT } from '../../../Config';
import Swal from "sweetalert2";
import Axios from "axios";

const ViewIndent = ({ IndentObj }) => {

    const [userDataSession, setUserDataSession] = useState(null);
    const [errors, setErrors] = useState({});
    const [rejectedReason, setRejectedReason] = useState("");
    const [viewLoading, setViewLoading] = useState(false);
    const [approveObj, setApproveObj] = useState([]);
    const [viewObj, setViewObj] = useState([]);
    const [approveLoading, setApproveLoading] = useState(false);
    const [indentProducts, setIndentProducts] = useState([]);

    const [offcanvasWidth, setOffcanvasWidth] = useState("45%");

    useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth < 768) {
          setOffcanvasWidth("75%");
        } else {
          setOffcanvasWidth("45%");
        }
      };

      handleResize();

      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
        } else {
            console.log("User data not found in sessionStorage");
        }
        console.log(IndentObj, 'gettoiiong from indent list.')
    }, []);

    const [approvedQuantities, setApprovedQuantities] = useState(
        indentProducts.reduce((acc, product) => {
            acc[product.ProductId] = product.Approvedqty || 0;
            return acc;
        }, {})
    );

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const editFormatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        const fetchData = () => {
            setViewLoading(true);
            Axios.get(`${API_BASE_URL}${GET_STOCK_INDENT_LIST}?OrgId=${userDataSession?.OrgId}&IndentNo=${IndentObj.IndentNo}`)
            .then((response) => {
                if (response.data.Status) {
                setIndentProducts(response.data.ResultData);
                console.log(response.data.ResultData);
                setViewLoading(false);
                } else {
                console.error("Error fetching data:", response.data.Message);
                }
            })
            .catch((error) => {
                setViewLoading(false);
                console.error("Error fetching data:", error);
            });
        };
        fetchData();
        setViewObj(IndentObj);
    }, [userDataSession, IndentObj]);

    const showApproveModal = (dataObj) => {
        setApproveObj(dataObj);
    };

    const handleApprovedQtyChange = (productId, value, reqQty) => {
        if (Number(value) > Number(reqQty)) {
          // If approved quantity is greater than requested quantity, show error
          setErrors((prevErrors) => ({
            ...prevErrors,
            [productId]: `Approved quantity cannot exceed requested quantity (${reqQty})`,
          }));
        } else {
          // If valid, remove the error and update the quantity
          setErrors((prevErrors) => ({
            ...prevErrors,
            [productId]: null,
          }));
    
          setApprovedQuantities((prevQuantities) => ({
            ...prevQuantities,
            [productId]: value,
          }));
        }
    };
    
    const handleApprovedSubmit = async (e) => {
        e.preventDefault();
        setApproveLoading(true);
        console.log(approveObj, approveLoading);
        const requestData = {
          StockIndent: [
            {
              OrgId: userDataSession?.OrgId,
              StoreId: viewObj?.StoreId,
              IndentDt: editFormatDate(viewObj?.IndentDt),
              Operation: "APPROVE",
              UserId: userDataSession.UserId,
              IndentNo: viewObj?.IndentNo,
            },
          ],
          ProductDetails: indentProducts?.map((product) => ({
            IndentId: product.IndentId ? product.IndentId : 0,
            ProductId: product.ProductId,
            Quantity: product.ReqQty,
            Approvedqty: approvedQuantities[product.ProductId],
          })),
          Type: "Update",
        };
    
        console.log(requestData, "sending to api");
    
        Axios.post(`${API_BASE_URL}${INSERT_STOCK_INDENT}`, requestData)
          .then((response) => {
            console.log("Response:", response.data[0].Success);
    
            if (response.data[0].Success === 1) {
              setApproveLoading(false);
              Swal.fire({
                title: `Stock Indent Updated Successfully.`,
                icon: "success",
              }).then((result) => {
                if (result.isConfirmed || result.isDismissed) {
                  window.location.reload();
                }
              });
            } else {
              setApproveLoading(false);
              Swal.fire({
                title: "Error",
                text: "Failed to update Stock Indent.",
                icon: "error",
              });
            }
          })
          .catch((error) => {
            setApproveLoading(false);
            console.error("Error:", error);
            Swal.fire({
              title: "Error",
              text: "Failed to update Stock Indent.",
              icon: "error",
            });
          });
    };

    const handleReject = async (rejectObj) => {
        const payload = {
          IndentStatus: 4,
          OrgId: userDataSession?.OrgId,
          IndentNo: rejectObj.IndentNo,
          StoreId: rejectObj.StoreId,
          Reason: rejectedReason || "null",
          UserId: userDataSession.UserId,
        };
    
        console.log(payload, "data sending to reject API");
    
        try {
          const response = await fetch(`${API_BASE_URL}${UPDATES_INDENT_STATUS}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });
    
          const data = await response.json();
          console.log(data);
    
          if (data[0].Status == "Success") {
            Swal.fire({
              title: `Indent Rejected Successfully.`,
              icon: "success",
            }).then((result) => {
              if (result.isConfirmed || result.isDismissed) {
                window.location.reload();
              }
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "Failed to Reject Indent.",
              icon: "error",
            });
          }
        } catch (error) {
          console.error("Error rejecting indent", error);
        }
    };
    

    return (
        <div className="offcanvas offcanvas-end" tabIndex={-1} id="offcanvasRightIndView" aria-labelledby="offcanvasRightLabel"
              style={{ maxWidth: offcanvasWidth }}>
            <div className="offcanvas-header">
                <h4 id="offcanvasRightLabel">
                    View Indent <span className="text-info">({viewObj?.IndentNo})</span>
                </h4>
                <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" />
            </div>{" "}
            <hr />
            <div className="offcanvas-body">
                <form onSubmit={handleApprovedSubmit}>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 mb-3">
                            <label className="form-label">Store</label>
                            <input type="text" className="form-control" placeholder="Store Name" value={viewObj?.StoreName}
                                style={{ cursor: "not-allowed" }} readOnly />
                        </div>
                        <div className="col-lg-6 col-md-6 mb-1">
                            <label className="form-label">Date</label>
                            <input type="text" className="form-control" placeholder="Date" value={formatDate(viewObj?.IndentDt)}
                                style={{ cursor: "not-allowed" }} readOnly />
                        </div>

                        <div className="col-12 table-responsive mt-2" style={{ maxHeight: '20rem', overflowY: 'auto' }}>
                            <table className="table datanew">
                                <thead className="sticky-top">
                                    <tr>
                                        <th className="">#</th>
                                        <th className="">Product</th>
                                        <th className="">Request Qty {viewObj?.IndentStatus}</th>
                                        <th
                                         className={ [1, 2, 4, 3].includes(userDataSession?.RoleId) ?
                                            viewObj?.IndentStatus===2 || viewObj?.IndentStatus===4 || viewObj?.IndentStatus===3
                                            ? "d-block" : "d-none" : "d-none" }
                                            >
                                            Approval Qty
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {viewLoading ? (
                                    <tr>
                                        <td colSpan="100%" className="text-center">
                                            <div className="loader m-auto"></div>
                                        </td>
                                    </tr>
                                    ) : (
                                    indentProducts &&
                                    indentProducts?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.ProductName}</td>
                                        <td>
                                            <input type="number" className="form-control" style={{ cursor: "not-allowed" ,
                                                width: "9rem" }} value={item.ReqQty} readOnly />
                                        </td>
                                        <td>
                                            <input type="number" className={`form-control ${ [1, 2, 4,
                                                3].includes(userDataSession?.RoleId) ? viewObj?.IndentStatus===2 ||
                                                viewObj?.IndentStatus===4 || viewObj?.IndentStatus===3 ? "d-block" : "d-none"
                                                : "d-none" }`} placeholder="Enter approval qty" value={
                                                approvedQuantities[item.ProductId] || item.Approvedqty } onChange={(e)=>
                                            handleApprovedQtyChange(
                                            item.ProductId,
                                            e.target.value,
                                            item.ReqQty
                                            )
                                            }
                                            style={{ width: "10rem" }}
                                            readOnly={
                                            userDataSession.RoleId === 3 ||
                                            [3, 5].includes(viewObj.IndentStatus)
                                            }
                                            />
                                            {errors[item.ProductId] && (
                                            <div className="text-danger">
                                                {errors[item.ProductId]}
                                            </div>
                                            )}
                                        </td>
                                    </tr>
                                    ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className={`mt-3 ${ viewObj?.IndentStatus===3 || viewObj?.IndentStatus===2 ? "d-block" : "d-none"
                            }`}>
                            <label className="form-label">Reason</label>
                            <textarea className="form-control col-12" placeholder="Enter reason for reject.."
                                value={rejectedReason} onChange={(e)=> setRejectedReason(e.target.value)}
                ></textarea>
                        </div>
                    </div>

                    <div className="modal-footer-btn d-flex justify-content-end">
                        <button type="button" className="btn btn-cancel me-2" data-bs-dismiss="offcanvas" aria-label="Close">
                            Cancel
                        </button>
                        <button type="submit" 
                            className={`btn btn-success me-2 ${ [1, 2, 4].includes(userDataSession?.RoleId) ?
                            viewObj?.IndentStatus===4 || viewObj?.IndentStatus===2 ? "d-block" : "d-none" : "d-none" }`}
                            onClick={()=>
                            showApproveModal(viewObj)}
                        >
                            Approve <i className="fa-regular fa-circle-check ms-1"></i>
                        </button>
                        <button type="button" 
                            className={`btn btn-danger me-2 ${ [1, 2, 4].includes(userDataSession?.RoleId) ?
                            viewObj.IndentStatus===3 || viewObj?.IndentStatus===2 ? "d-block" : "d-none" : "d-none" }`}
                            onClick={()=>
                            handleReject(viewObj)}
                        >
                            Reject <i className="fa-regular fa-circle-xmark ms-1"></i>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

ViewIndent.propTypes = {
    IndentObj: PropTypes.object.isRequired,
};

export default ViewIndent
